import {load} from '@shopify/theme-sections';
import smoothscroll from 'smoothscroll-polyfill';

import ProductSlider from '../sections/product-slider';
import Recommendations from '../sections/recommendations-collection';
import RecentlyViewed from '../components/recently-viewed';
import Skintone from '../sections/product-skintone';
import SkintoneSlider from '../sections/product-skintone-slider';
import TestimonialSlider from '../snippets/article-slider';
import Testimonial from '../sections/testimonials-two';
import SwatchProduct from '../sections/swatch';
import AccordionReadmore from '../components/accordion-read-more';
import Ingredients from '../components/ingredients-hide-show';
import Readmore from '../sections/product-readmore';
import katiesStory from '../sections/katies-story';
import backToTop from '../sections/product-back-to-top';
import RealWomen from '../sections/product-real-women';
// import KlaviyoCheck from '../sections/product-klaviyo-check';

import '../sections/product';

if (document.body.classList.contains('template-product')) {
  SkintoneSlider().init();

  RecentlyViewed().init();
  Skintone().init();
  TestimonialSlider().init();
  Testimonial().init();

  SwatchProduct({
    container: '[js-swatch-product="main"]',
    updateSlider: false,
  }).init();

  katiesStory().init();
  Readmore().init();

  backToTop().init();
  RealWomen().init();
  ProductSlider().init();

  // KlaviyoCheck().init();

  if (document.querySelector('.accordion') !== null) {
    AccordionReadmore().init();
  }

  const ingredients = document.getElementById('ingredients-hideShow');
  if (typeof ingredients !== 'undefined' && ingredients != null) {
    Ingredients();
  }

  smoothscroll.polyfill();

  setTimeout(() => {
    Recommendations().init();
  }, 1000);

  load('*');
}
